const state = {
    owner: false
}

export default {
    namespaced: true,
    state,
};